import React from 'react';
import {
  AUTH_PROPERTY_COLUMN_TYPE,
  DateAuthProperty,
  FieldWrapper,
  MailAddressAuthProperty,
  MonthDayAuthProperty,
  NumberAuthProperty,
  PasswordHashAuthProperty,
  SynergyIdAuthProperty,
  TextAuthProperty,
} from 'shared';
import { DateItem } from './Date';
import { MailAddress } from './MailAddress';
import { MonthDay } from './MonthDay';
import { NumberItem } from './Number';
import { PasswordHash } from './PasswordHash';
import { SynergyId } from './SynergyId';
import { Text } from './Text';
import { FormFieldProps } from './shared';

const { synergyId, text, number, mailAddress, passwordHash, date, monthDay } =
  AUTH_PROPERTY_COLUMN_TYPE;

const FormFieldInput: React.FC<FormFieldProps> = ({
  property,
  disabled,
  design,
}) => {
  switch (property.detail.columnType) {
    case text: {
      return (
        <Text
          disabled={disabled}
          design={design}
          property={property as TextAuthProperty}
        />
      );
    }
    case synergyId: {
      return (
        <SynergyId
          disabled={disabled}
          design={design}
          property={property as SynergyIdAuthProperty}
        />
      );
    }
    case number: {
      return (
        <NumberItem
          disabled={disabled}
          design={design}
          property={property as NumberAuthProperty}
        />
      );
    }
    case mailAddress: {
      return (
        <MailAddress
          disabled={disabled}
          design={design}
          property={property as MailAddressAuthProperty}
        />
      );
    }
    case passwordHash: {
      return (
        <PasswordHash
          disabled={disabled}
          design={design}
          property={property as PasswordHashAuthProperty}
        />
      );
    }
    case date: {
      return (
        <DateItem
          disabled={disabled}
          design={design}
          property={property as DateAuthProperty}
        />
      );
    }
    case monthDay: {
      return (
        <MonthDay
          disabled={disabled}
          design={design}
          property={property as MonthDayAuthProperty}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export const FormField: React.FC<FormFieldProps & { className?: string }> = ({
  property,
  disabled,
  design,
  className,
}) => {
  const { name, note, comment, displayRequiredLabel } = property;
  return (
    <FieldWrapper
      className={className}
      required={true}
      displayRequiredLabel={displayRequiredLabel}
      name={name}
      note={note ?? ''}
      comment={comment ?? ''}
      design={design}
      propertyId={property.propertyId}
    >
      <FormFieldInput property={property} disabled={disabled} design={design} />
    </FieldWrapper>
  );
};
